var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreyLocationMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 42,
    viewBox: "0 0 37 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.8747 30.5523L21.5931 39.7339C20.7728 40.5446 19.6607 41 18.5011 41C17.3415 41 16.2294 40.5446 15.4091 39.7339L6.12532 30.5523C3.67799 28.1312 2.01137 25.0466 1.3362 21.6885C0.661031 18.3304 1.00764 14.8497 2.3322 11.6865C3.65676 8.52328 5.89978 5.81963 8.77762 3.91746C11.6555 2.01528 15.0389 1 18.5 1C21.9611 1 25.3445 2.01528 28.2224 3.91746C31.1002 5.81963 33.3432 8.52328 34.6678 11.6865C35.9924 14.8497 36.339 18.3304 35.6638 21.6885C34.9886 25.0466 33.322 28.1312 30.8747 30.5523Z",
    fill: "#D9D9D9",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyLocationMarker);
export default __webpack_public_path__ + "static/media/grey-location-marker.01da57af5c1b5d70c752a9c3bf32778e.svg";
export { ForwardRef as ReactComponent };